import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../redux/store/store';
import { getPaginatedData } from '../../../utils/strings/strings';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { GetRequestProductsDBThunk, numberRequestProductsByPage } from '../../../redux/slices/components/RequestProducts/requestProductsDataSlice';


const PaginationRequestProductsTableRow = () => {
    
    const { t } = useTranslation()

    const dispatch = useAppDispatch()
    
    const productsToShow = useSelector((state: RootState) => state.requestProductsData.productsToShow);
    const typeProduct = useSelector((state: RootState) => state.requestProductsData.typeProduct);
    const jobId = useSelector((state: RootState) => state.requestProductsData.jobId);
    const loadingContainer = useSelector((state: RootState) => state.requestProductsData.loadingContainer);
    const productsIds = useSelector((state: RootState) => state.requestProductsData.productsIds);
    const LastEvaluatedKey =  useSelector((state: RootState) => state.requestProductsData.LastEvaluatedKey);
    const limit = useSelector((state: RootState) => state.requestProductsData.limit);
    const page = useSelector((state: RootState) => state.requestProductsData.page);
    const total = useSelector((state: RootState) => state.requestProductsData.total);
    const stringToSearch = useSelector((state: RootState) => state.requestProductsData.stringToSearch);

    const paginate = (direction: string) => {
        //console.log("lastEvaluatedKey", LastEvaluatedKey)
        if(loadingContainer)
            return

        /*
                if(status === newStatus)
            navigate(`/manage-bug-reports?limit=${limit}`)
        else
            navigate(`/manage-bug-reports?limit=${limit}&status=${newStatus}`)
        */

        if(direction === "forward" && LastEvaluatedKey){
            dispatch(GetRequestProductsDBThunk({ page: page + 1, limit, LastEvaluatedKey, typeProduct, jobId}))
        }
        else if(direction === "backward" && page !== 1){
            if(page === 2){
                dispatch(GetRequestProductsDBThunk({ page: page - 1, limit, LastEvaluatedKey: undefined, typeProduct, jobId }))
            }else{
                const lastItem = productsIds[((page - 2) * limit) - 1]
                const lastKeyId = lastItem
                    
                dispatch(GetRequestProductsDBThunk({ page: page - 1, limit, LastEvaluatedKey: lastKeyId, typeProduct, jobId }))
            }
        }

    }

    const changeNumberOfPages = (newNumberOfPages: number) => {

        const totalUserReportssUntilNow = (page - 1) * limit + productsToShow.length 

        if(newNumberOfPages > totalUserReportssUntilNow){
            // bring page 1 with same type
            dispatch(GetRequestProductsDBThunk({ 
                page: 1, 
                limit: newNumberOfPages, 
                typeProduct,
                jobId,
            }))
        }else{
            dispatch(GetRequestProductsDBThunk({ 
                page: 1, 
                limit: newNumberOfPages, 
                typeProduct,
                jobId,
            }))
        }
    }


    const changeNumberOfPagesSearchBar = (newNumberOfPages: number) => {
        
        if(!stringToSearch)
            return

        const totalRequestProductsUntilNow = (page - 1) * limit + productsToShow.length 

        if(newNumberOfPages > totalRequestProductsUntilNow ){
            dispatch(GetRequestProductsDBThunk({ page: 1, limit: newNumberOfPages, typeProduct, jobId }))
        }else{
            dispatch(GetRequestProductsDBThunk({ page: 1, limit: newNumberOfPages, typeProduct, jobId }))
        }
    }

    return (
        <div className="con-row-pagination flex flex-jc-sb flex-ai-center width-100">
            
            <div className=""></div>
            
            <div className="flex flex-ai-center">
                <button 
                    onClick={() => paginate("backward")} 
                    className={`fs-24 mr-12 ${page === 1 ? "disable-color" : "c-black pointer"}`}
                    disabled={page === 1 ? true : false} 
                >
                    <FontAwesomeIcon icon={solid("arrow-left-long")}  />
                </button>
                <p className="fs-15 fw-700">{page}</p>
                <button 
                    onClick={() => paginate("forward")}  
                    className={`fs-24 ml-12 ${LastEvaluatedKey?.id ?  "c-black pointer" : "disable-color"}`}
                    disabled={!LastEvaluatedKey?.id ? true : false}
                >
                    <FontAwesomeIcon icon={solid("arrow-right-long")}  />
                </button>
            </div>
            
            <div className="flex">
                {
                    numberRequestProductsByPage.map((numberPages: number, index: number) => {
                        return (
                            <button 
                                key={index}
                                disabled={numberPages === limit}
                                className={`fs-14 fw-500 mr-12 ${numberPages === limit ? "c-black" : "disable-color pointer"}`}
                                onClick={() => { 
                                    alert("hi")
                                    if(stringToSearch)
                                        changeNumberOfPagesSearchBar(numberPages)
                                    else
                                        changeNumberOfPages(numberPages)
                                }}
                            >
                                {numberPages}
                            </button>
                        )
                    })
                }
                <p className="fw-500 fs-14 ml-10">
                    {`${getPaginatedData(page, limit, total)} ${t("General:label_267")} ${total}`}
                </p>
            </div>

        </div>
    )
}

export default React.memo( PaginationRequestProductsTableRow )